import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import {
  AreaUnitEnum,
  CaseAccessLevelEnum,
  CaseClient,
  CaseMemberClient,
  OwnNewDevelopmentEnum,
  OwnerOrEmployeeEnum,
  ProjectOwnershipClient,
  UserClient,
  ProjectOwnership,
  CaseMember,
  Case,
  DevelopmentTrackRecord,
  ApplicationUserCrudClient,
  CaseCrudClient,
  ProjectOwnershipCrudClient,
  DevelopmentTrackRecordCrudClient,
} from "@src/apis/ModularClient";
import { IndexService } from "@js/services/IndexService";
import { Expand } from "@ccq/ts-lib";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class DevelopmentExperienceController {
  isLoggedInUser: boolean = false;

  case: Expand<
    Case,
    {
      readonly developmentInput: true;
    }
  >;
  caseTitle: string;

  message: string = "";
  modal: boolean = false;

  //Check if shareholder is Admin or current user
  isAdmin: boolean = false;
  shareholder: CaseMember;
  isPrimaryApplicant: boolean;

  //share shareholder
  shareContext: number = null;
  shareSuplId: number = null;
  userFirstName: string;
  shareNote: string;
  shareFirstName: string;
  shareSurname: string;
  shareEmail: string;
  showShare: boolean = false;

  dataLoading: boolean = false;
  selectedObject: Expand<ProjectOwnership, { readonly developmentTrackRecords: true }>;
  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  fetchingObjects: boolean;
  fetchingObject: boolean;
  show: boolean[] = [];
  showAutofill: boolean = false;

  step: number = 1;
  caseid: number;

  formattedAcquisitionDate: any[] = [];

  error: boolean = false;
  saving: boolean = false;
  saved: boolean = false;

  devexperienceId: number;

  multiPartForm1: ng.IFormController;
  assetform: ng.IFormController;

  //array describing form sections
  formSectionNames = [
    {
      label: "Ownership",
      visible: true,
    },
    {
      label: "Shareholders",
      visible: true,
    },
    {
      label: "Track Record",
      visible: true,
    },
  ];

  applicantNo: number = 0;

  guidanceCheckbox: boolean = true;

  applicantForm: ng.IFormController;
  showDelete: boolean = false;
  confirmDeleteApplicant: CaseMember;
  tempApplicant: CaseMember;
  showQuickEditModal: boolean = false;
  applicant: CaseMember;
  disableQuickEditSave: boolean = false;
  isAddShareholder: boolean;

  showAdd: boolean = false;
  showEdit: boolean = false;
  addEditApplicant: CaseMember;

  owners: CaseMember[];
  IsBroker: boolean = false;
  maxDateForDateField: Date = new Date("Jan 01 3000");

  howWillYouOwnNewDevelopmentOptions = [
    { label: "UK Limited Company", value: 1 },
    { label: "UK Limited Liability Partnership", value: 2 },
    { label: "Personal Names", value: 3 },
    { label: "Overseas Limited Company", value: 4 },
    { label: "Pension Fund", value: 5 },
    { label: "Other(Please Specify)", value: 6 },
  ];

  static $inject = [
    "$window",
    "$rootScope",
    "$q",
    "$routeParams",
    "ProjectOwnershipClient",
    "$location",
    "CaseService",
    "CaseClient",
    "$cookies",
    "CaseMemberClient",
    "RoleService",
    "UserClient",
    "IndexService",
    "ApplicationUserCrudClient",
    "CaseCrudClient",
    "ProjectOwnershipCrudClient",
    "ODataHelper",
    "DevelopmentTrackRecordCrudClient",
  ];

  //private $subobjectservice: App.Services.SubobjectService
  constructor(
    private $window: ng.IWindowService,
    private $rootScope: ng.IRootScopeService,
    protected $q: ng.IQService,
    private $routeParams: ng.route.IRouteParamsService,
    private projectOwnershipClient: ProjectOwnershipClient,
    private $location: ng.ILocationService,
    private $caseService: CaseService,
    private caseClient: CaseClient,
    private $cookies: ng.cookies.ICookiesService,
    private caseMemberClient: CaseMemberClient,
    private roleService: RoleService,
    private userService: UserClient,
    private indexService: IndexService,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private caseCrudClient: CaseCrudClient,
    private projectOwnershipCrudClient: ProjectOwnershipCrudClient,
    private odataHelper: ODataHelper,
    private developmentTrackRecordCrudClient: DevelopmentTrackRecordCrudClient,
  ) {
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;

      this.userService.getCurrentUserAutofill().then((response) => {
        this.showAutofill = response;
      });
    }

    //Get step number
    if (this.$routeParams.StepNumber) {
      this.step =
        this.$routeParams.StepNumber > 8 || this.$routeParams.StepNumber < 1 ? 1 : this.$routeParams.StepNumber;
    }

    if (this.$routeParams.CaseId) {
      this.caseid = this.$routeParams.CaseId;
    }

    //existing devexperience
    if (this.$routeParams.Id && this.$routeParams.Id > 0) {
      this.devexperienceId = this.$routeParams.Id;

      //if (!this.selectedObject) {
      this.odataHelper
        .getOne(this.projectOwnershipCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.Id),
            },
          },
        })
        .then((response) => {
          if (response == null) {
            if (this.isLoggedInUser) {
              this.$location.path("/userdashboard");
            } else {
              this.$location.path("/landing");
            }
          } else {
            this.odataHelper
              .getMany(this.developmentTrackRecordCrudClient, {
                filter: {
                  developmentExperienceId: {
                    eq: Number(this.$routeParams.Id),
                  },
                },
              })
              .then((developmentTrackRecords) => {
                this.selectedObject = response as typeof response & { developmentTrackRecords: any[] };
                this.selectedObject.developmentTrackRecords = developmentTrackRecords;
                if (this.selectedObject.howWillYouOwnNewDevelopment <= 0) {
                  this.selectedObject.howWillYouOwnNewDevelopment = 1;
                }

                this.caseMemberClient.fetchByCaseId(this.caseid).then((response) => {
                  this.owners = response;

                  this.selectedObject.howManyOwnersShareholdersOrPartners = this.owners.length;
                });

                this.selectedObject.developmentTrackRecords.forEach((d, index) => {
                  if (d.acquistionDate != null) {
                    this.formattedAcquisitionDate[index] = new Date(d.acquistionDate.toString());
                  }
                });
              });
          }
        })
        .finally(() => {
          this.fetchingObjects = false;
        });
    } else if (this.caseid) {
      //assoicate the case with it so when it is saved the server attaches it to the case
      this.selectedObject = {
        parentCaseToAssoicateWithOnCreation: this.caseid,
        developmentTrackRecords: [],
      } as Expand<ProjectOwnership, { readonly developmentTrackRecords: true }>;
    } else {
      this.selectedObject = {
        developmentTrackRecords: [],
      } as Expand<ProjectOwnership, { readonly developmentTrackRecords: true }>;
    }

    this.odataHelper
      .getOne(this.caseCrudClient, {
        filter: {
          id: {
            eq: Number(this.$routeParams.CaseId),
          },
        },
        expand: {
          developmentInput: true,
        },
      })
      .then((response) => {
        this.case = response;
        this.caseTitle = response.developmentInput.searchName;
        this.checkForPrimaryUser();
      });

    if (this.$routeParams.Id < 1) {
      // no develoment experience id
      this.save(false).then((response) => {
        this.devexperienceId = response;
        this.go("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/1");
      });
    } else if (!this.$routeParams.StepNumber) {
      this.go("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/" + this.step);
    }

    if (this.$routeParams.ApplicantNo) {
      this.applicantNo = this.$routeParams.ApplicantNo;
    }

    this.updateGuidanceState();
    this.checkForAdmin();
    this.checkIfOnlyBroker();

    $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      this.updateGuidanceState();
    });
  }

  checkForAdmin(): void {
    this.dataLoading = true;
    this.roleService
      .isAdminUser()
      .then((response) => {
        this.isAdmin = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkIfOnlyBroker() {
    this.dataLoading = true;
    this.roleService
      .isBroker()
      .then((response) => {
        this.IsBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkForPrimaryUser(): boolean {
    if (
      (this.$rootScope as any).currentUser &&
      this.case &&
      (this.$rootScope as any).currentUser.UuerName == this.case.ownerUser
    ) {
      this.isPrimaryApplicant = true;
      return true;
    }

    this.isPrimaryApplicant = false;
    return false;
  }

  clientAccountAccessCheck(shareholder: CaseMember): boolean {
    if (this.owners) {
      this.shareholder = this.owners.find((x) => x.userId == shareholder.userId);
    }

    if (this.shareholder.userId == (this.$rootScope as any).currentUser?.id) {
      return true;
    }

    return false;
  }

  updateGuidanceState() {
    this.guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;
  }

  getGuidanceSwitchState() {
    if (!this.$cookies.get("guidance")) {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "on") {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "off") {
      this.guidanceCheckbox = false;
    } else {
      this.guidanceCheckbox = true;
    }
    return this.guidanceCheckbox;
  }

  addApplicantPopUp() {
    delete this.addEditApplicant;
    this.showAdd = true;
  }

  resetApplicant() {
    this.applicantForm.$setPristine();
    this.applicantForm.$setUntouched();
    this.addEditApplicant = {} as CaseMember;
    this.showAdd = false;
  }

  updateApplicant(applicant: CaseMember): void {
    this.addEditApplicant = applicant;
    this.tempApplicant = { ...this.addEditApplicant };
    this.showEdit = true;
  }

  saveUpdatedApplicant(applicant: CaseMember): void {
    this.disableQuickEditSave = true; // this is just because sometimes the save takes a little while and the user could click the save button again
    applicant.caseId = this.case.id;

    if (!applicant.postalAddress) {
      applicant.postalAddress = {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      };
    }

    applicant.addressHistory = applicant.addressHistory ?? "";
    applicant.creditBankruptDetail = applicant.creditBankruptDetail ?? "";
    applicant.creditRefusedDetail = applicant.creditRefusedDetail ?? "";
    applicant.creditConvictionDetails = applicant.creditConvictionDetails ?? "";
    applicant.creditCcjDetail = applicant.creditCcjDetail ?? "";
    applicant.creditDefaultedDetail = applicant.creditDefaultedDetail ?? "";
    applicant.creditCcjDetail = applicant.creditCcjDetail ?? "";
    applicant.creditRepossessedDetail = applicant.creditRepossessedDetail ?? "";
    applicant.creditStepInRightsExercisedDetail = applicant.creditStepInRightsExercisedDetail ?? "";
    applicant.creditSanctionedDetail = applicant.creditSanctionedDetail ?? "";
    applicant.creditRelatedDetail = applicant.creditRelatedDetail ?? "";
    applicant.creditWelfareDetail = applicant.creditWelfareDetail ?? "";
    applicant.visaStatus = applicant.visaStatus ?? "";
    applicant.furtherInformation = applicant.furtherInformation ?? "";
    applicant.professionalQualifications = applicant.professionalQualifications ?? "";
    applicant.sKillsInOrder = applicant.sKillsInOrder ?? "";
    applicant.nationality = applicant.nationality ?? "";
    applicant.phoneNumber = applicant.nationality ?? "";

    this.caseMemberClient
      .addorUpdateCaseMember(this.isAddShareholder, applicant)
      .then((response) => {
        response.dateOfBirth = applicant.dateOfBirth;
        const existingShareholder = this.owners.find((s) => s.id == response.id);

        // If found then we're updating
        if (existingShareholder) {
          this.owners = this.owners.filter((member) => member.id != applicant.id);
          this.owners.push(response);
        } else {
          this.owners.push(response);
        }
      })
      .finally(() => {
        delete this.addEditApplicant;
        this.showEdit = false;
        this.showAdd = false;
        this.disableQuickEditSave = false;
      });
  }

  cancelUpdateApplicant() {
    this.showEdit = false;
    this.owners = this.owners.filter((applicant) => applicant.id != this.tempApplicant.id);
    this.owners.push(this.tempApplicant); // Resets anything that is changed using the original data object
  }

  recordGuidanceCookie() {
    let guidanceSwitchState: string;
    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    if (this.guidanceCheckbox == true) {
      guidanceSwitchState = "on";
    } else {
      guidanceSwitchState = "off";
    }
    this.$cookies.put("guidance", guidanceSwitchState, { expires: expiryDate });
    this.$rootScope.$broadcast("guidanceStateChanged");
  }

  formChanged(): void {
    (this.$rootScope as any).formSaved = false;
  }

  save(isFormComplete: boolean): ng.IPromise<number> {
    let defer = this.$q.defer<number>();
    if (!this.selectedObject) {
      return defer.promise;
    }

    if (!this.roleService.IsLender) {
      this.saving = true;

      this.formattedAcquisitionDate.forEach((d, index) => {
        this.selectedObject.developmentTrackRecords[index].acquistionDate = d;
      });
      const { developmentTrackRecords, ...onlyprojectOwnership } = this.selectedObject;
      let saveRequest = this.projectOwnershipCrudClient
        .patch(onlyprojectOwnership)
        .then((response) => {
          //set ID of selectedobject
          this.selectedObject.id = response.id;
          //after save take out saving assoication each time
          this.selectedObject.parentCaseToAssoicateWithOnCreation = null;
          this.setAllFormsPristine();
          this.saved = true;
          if (isFormComplete) {
            const markComplete = {
              id: this.caseid,
              developmentAppraisalComplete: true,
            } as Case;
            this.caseClient.addUpdateReturnOnlyID(markComplete).then((response) => {
              this.goToCaseDashboard(true);
            });
          }
          defer.resolve(response.id as number);
          return response;
        })
        .catch((response) => {
          defer.reject(response);
          this.error = true;
        })
        .finally(() => {
          this.saving = false;
        });
    }
    return defer.promise;
  }

  next(): void {
    //go to next screen
    this.step++;
    if (this.step > 1 && this.step <= 3) {
      this.go("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/" + this.step);
      (this.$rootScope as any).formSaved = this.roleService.IsLender;
    } else {
      this.$location.path("/casedashboard/" + this.caseid);
    }
  }

  back(): void {
    if (this.step > 1) {
      this.step--;
      this.go("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/" + this.step);
      (this.$rootScope as any).formSaved = this.roleService.IsLender;
    } else if (this.step <= 1) {
      this.$location.path("/casedashboard/" + this.caseid);
    }
  }

  goToCaseDashboard(blockSave?: boolean): void {
    if (this.roleService.IsLender == true) {
      this.$location.path("/casedashboard/" + this.caseid);
    } else {
      if (blockSave) {
        this.save(true).then((response) => {
          this.$location.path("/casedashboard/" + this.caseid);
          (this.$rootScope as any).formSaved = true;
        });
      } else {
        this.save(false).then(() => {
          this.$location.path("/casedashboard/" + this.caseid);
        });
      }
    }
  }

  setAllFormsPristine(): void {
    if (this.multiPartForm1) {
      this.multiPartForm1.$setPristine();
    }
  }

  updateComparable(index) {
    this.show[index] = true;
  }

  ShowCompanyOrPartnershipName(): boolean {
    if (
      this.selectedObject &&
      this.selectedObject.howWillYouOwnNewDevelopment != OwnNewDevelopmentEnum.PersonalNames &&
      this.selectedObject.hasTheCompanyOrPensionBeenFormedYet
    ) {
      return true;
    }
    return false;
  }
  ShowCompanyOrPartnershipNumber(): boolean {
    if (
      this.selectedObject &&
      this.selectedObject.howWillYouOwnNewDevelopment != OwnNewDevelopmentEnum.PersonalNames &&
      this.selectedObject.hasTheCompanyOrPensionBeenFormedYet
    ) {
      return true;
    }
    return false;
  }
  ShowPensionType(): boolean {
    if (
      this.selectedObject &&
      this.selectedObject.howWillYouOwnNewDevelopment == OwnNewDevelopmentEnum.PensionFund &&
      this.selectedObject.hasTheCompanyOrPensionBeenFormedYet
    ) {
      return true;
    }
    return false;
  }

  go(path): void {
    // Only need to save if user is NOT a lender (everything is in read-only mode for lender)
    if (this.roleService.IsLender == true) {
      this.$location.path(path);
    } else {
      this.save(false).then((response) => {
        this.devexperienceId = response;
        this.$location.path(path);
      });
    }
  }

  sum(a: number, b: number): number {
    return a + b;
  }

  getMethodOwningText(): string {
    let methodofowningnewdevelopmenttext;
    let nameOfSubParts;
    if (this.selectedObject && this.selectedObject.howWillYouOwnNewDevelopment) {
      this.formSectionNames.forEach((s) => (s.visible = true));
      switch (this.selectedObject.howWillYouOwnNewDevelopment) {
        case OwnNewDevelopmentEnum.UKLimitedCompany:
          methodofowningnewdevelopmenttext = "UK Limited Company";
          nameOfSubParts = "Shareholders";
          break;
        case OwnNewDevelopmentEnum.OverseasLimitedCompany:
          methodofowningnewdevelopmenttext = "Overseas Limited Company";
          nameOfSubParts = "Shareholders";
          break;
        case OwnNewDevelopmentEnum.Other:
          methodofowningnewdevelopmenttext = this.selectedObject.howWillYouOwnNewDevelopmentOther;
          nameOfSubParts = "Owners";
          this.formSectionNames[1].visible = false;
          //step = 2;
          break;
        case OwnNewDevelopmentEnum.PensionFund:
          methodofowningnewdevelopmenttext = "Pension Fund";
          nameOfSubParts = "beneficiaries";
          break;
        case OwnNewDevelopmentEnum.PersonalNames:
          methodofowningnewdevelopmenttext = "Personal Names";
          nameOfSubParts = "Owners";
          this.formSectionNames[1].visible = false;
          //step = 2;
          break;
        case OwnNewDevelopmentEnum.UKLimitedLiabilityPartnership:
          methodofowningnewdevelopmenttext = "UK Limited Liability Partnership";
          nameOfSubParts = "Partners";
          break;
        default:
      }
      return methodofowningnewdevelopmenttext;
    }
    return "";
  }

  /** Initialise the CaseMember for adding a new Shareholder/Applicant */
  initialiseNewApplicant() {
    this.addEditApplicant = {
      accessLevel: CaseAccessLevelEnum.Hidden,
      caseId: this.$routeParams.CaseId,
      isApplicant: true,
      order: this.owners && this.owners.length > 0 ? this.owners.length + 1 : 1,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
      addressHistory: "",
      creditBankruptDetail: "",
      creditCcjDetail: "",
      creditConvictionDetails: "",
      creditDefaultedDetail: "",
      creditRefusedDetail: "",
      creditRelatedDetail: "",
      creditRepossessedDetail: "",
      creditSanctionedDetail: "",
      creditStepInRightsExercisedDetail: "",
      creditWelfareDetail: "",
      email: "",
      firstName: "",
      furtherInformation: "",
      nationality: "",
      phoneNumber: "",
      professionalQualifications: "",
      sKillsInOrder: "",
      surname: "",
      visaStatus: "",
    } as CaseMember;
  }

  /**
   * Open the Shareholder/Applicant quick edit
   * @param applicant
   */
  openShareholderQuickEdit(applicant: CaseMember) {
    if (applicant) {
      this.isAddShareholder = false;
      this.applicant = applicant;
      this.tempApplicant = { ...this.applicant };
    } else {
      this.isAddShareholder = true;
      if (this.applicantForm) {
        this.applicantForm.$setPristine();
        this.applicantForm.$setUntouched();
      }

      this.initialiseNewApplicant();
    }

    this.showQuickEditModal = true;
  }

  /** Cancel any adding or editing of a Shareholder/Applicant */
  cancelShareholderQuickEdit() {
    if (this.tempApplicant && this.tempApplicant.id > 0) {
      this.owners = this.owners.filter((applicant) => applicant.id != this.tempApplicant.id);
      this.owners.push(this.tempApplicant);
    }

    this.closeShareholderQuickEdit();
  }

  /** Save a new or updated Shareholder/Applicant on quick add/edit */
  saveApplicant(): void {
    this.disableQuickEditSave = true; // this is just because sometimes the save takes a little while and the user could click the save button again

    this.caseMemberClient
      .addorUpdateCaseMember(true, this.addEditApplicant)
      .then((response) => {
        const existingShareholder = this.owners.find((s) => s.id == response.id);

        // If found then we're updating
        if (existingShareholder) {
          this.owners = this.owners.filter((member) => member.id != this.addEditApplicant.id);
          this.owners.push(response);
        } else {
          this.owners.push(response);
        }
      })
      .finally(() => {
        this.showQuickEditModal = false;
        this.applicantForm.$setPristine();
        this.applicantForm.$setUntouched();
        this.tempApplicant = {} as CaseMember;
        this.addEditApplicant = {} as CaseMember;
        this.disableQuickEditSave = false;
      });
  }

  deleteApplicant(): void {
    let id = this.confirmDeleteApplicant.id;

    this.caseMemberClient
      .markAsDeleteAndSetNextCaseMemberAsPrimary(this.caseid, this.confirmDeleteApplicant.id)
      .then((response) => {
        this.owners = response;
      });
    this.confirmDeleteApplicant = {} as CaseMember;
    this.showDelete = false;
  }

  deleteConfirmApplicant(applicant: CaseMember) {
    this.showDelete = true;
    this.confirmDeleteApplicant = { ...applicant };
  }

  /** Processing that should be done each time the modal closes - on cancel or save */
  closeShareholderQuickEdit() {
    this.showQuickEditModal = false;
    this.applicantForm.$setPristine();
    this.applicantForm.$setUntouched();
    this.tempApplicant = {} as CaseMember;
    this.applicant = {} as CaseMember;
  }

  isInvalid() {
    if (this.selectedObject) {
      if (!this.selectedObject.hasTheCompanyOrPensionBeenFormedYet) {
        return false;
      }
      if (this.selectedObject.companyPensionOrPartnershipName && this.selectedObject.companyOrPartnershipNumber) {
        return false;
      }
      return true;
    }
  }

  goToApplicantDetails(applicant: CaseMember): void {
    //change applicant.id to index (use a for loop to iterate through dto)
    let applicantId;

    for (let i = 0; i <= this.owners.length - 1; i++) {
      if (this.owners[i].id == applicant.id) {
        applicantId = i;
      }
    }
    if (applicantId || applicantId == 0) {
      this.go("/applicantdetails/" + this.caseid + "/" + this.devexperienceId + "/" + applicant.id + "/1");
    }
  }

  invite(applicant: CaseMember) {
    this.caseMemberClient
      .inviteApplicant(applicant.uniqueRef)
      .then((i) => {
        this.modal = true;
        this.message =
          "A request has been sent to " +
          applicant.firstName +
          " " +
          applicant.surname +
          " complete their shareholder profile.";
      })
      .catch((error) => {
        this.modal = true;
        this.message =
          "There was a problem sending the invite request to " +
          applicant.firstName +
          " " +
          applicant.surname +
          ". Please try again later.";
      });
  }

  /**
   * Determines when to show/hide the Invite button
   * @param shareholder
   */
  showInviteButton(shareholder: CaseMember) {
    // If the shareholder has already been verified then don't show the button
    if (shareholder.isVerified) {
      return false;
    }

    // At least 2 of the security questions should be answered
    let count = 0;

    if (shareholder.phoneNumber) {
      count++;
    }

    if (shareholder.postalAddress.postCode) {
      count++;
    }

    if (shareholder.dateOfBirth) {
      count++;
    }

    if (count >= 2) {
      return true;
    }

    return false;
  }

  async openSendToBorrower(shareholder: CaseMember, shareContext: number) {
    this.shareContext = shareContext;
    this.shareSuplId = shareholder.id;
    if ((await this.indexService.currentUser).userName !== this.case.developmentInput.ownerUser) {
      this.userFirstName = "";
    } else {
      this.odataHelper
        .getOne(this.applicationUserCrudClient, {
          filter: { id: { eq: await this.indexService.currentUserId } },
          select: {
            firstName: true,
          },
        })
        .then((response) => {
          this.userFirstName = response.firstName;
        });
    }

    const message =
      `Please take a look and complete the information for  ` +
      shareholder.firstName +
      `\n\nIf you need my help or want me to complete this information with you on a call, then please contact me as soon as possible.`;

    this.shareNote = message;

    this.shareEmail = shareholder.email;
    this.shareFirstName = shareholder.firstName;
    this.shareSurname = shareholder.surname;

    //if (this.$cookies.get('access_token')) {
    //    this.userService.getcurentuserrecord().then((result) => {

    //        if (this.selectedUser.UserName !== this.case.DevelopmentInput.OwnerUser) {
    //            this.shareEmail = this.case.DevelopmentInput.OwnerUser;
    //            this.shareFirstName = "";
    //            this.shareSurname = "";
    //        }
    //        else {
    //            this.shareEmail = result.Email;
    //            this.shareFirstName = result.FirstName;
    //            this.shareSurname = result.LastName;
    //        }
    //    });
    //}

    this.showShare = true;
  }

  sendToBorrower() {
    this.dataLoading = true;
    this.caseClient
      .sendNote(
        this.shareFirstName,
        this.shareSurname,
        this.shareEmail,
        this.shareNote,
        this.case.id,
        this.shareContext,
        this.shareSuplId,
        this.case.developmentExperienceId,
      )
      .then((success) => {
        this.showShare = false;
        this.dataLoading = false;
      });
  }

  autoFillOwnershipDetails() {
    this.selectedObject.howWillYouOwnNewDevelopment = OwnNewDevelopmentEnum.UKLimitedCompany;
    this.selectedObject.hasTheCompanyOrPensionBeenFormedYet = true;
    this.selectedObject.companyPensionOrPartnershipName = "Globe Results Limited";
    this.selectedObject.companyOrPartnershipNumber = "12322370";
    this.selectedObject.excludedLenders = "Example Lender";

    this.selectedObject.developmentTrackRecords = [];

    let newDevelopmentTrackRecord = {
      developmentTrackRecordNumber: 1,
      developmentExperienceId: this.selectedObject.id,
      areaUnit: 1,
      developmentTrackRecordType: null,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as DevelopmentTrackRecord;

    this.selectedObject.developmentTrackRecords.push(newDevelopmentTrackRecord);

    newDevelopmentTrackRecord = {
      developmentTrackRecordNumber: 2,
      developmentExperienceId: this.selectedObject.id,
      areaUnit: 1,
      developmentTrackRecordType: null,
      postalAddress: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postCode: "",
      },
    } as DevelopmentTrackRecord;

    this.selectedObject.developmentTrackRecords.push(newDevelopmentTrackRecord);
    this.selectedObject.developmentTrackRecords[0].ownerOrEmployee = OwnerOrEmployeeEnum.Owner;
    this.selectedObject.developmentTrackRecords[0].postalAddress.addressLine1 = "32 Brookside Road";
    this.selectedObject.developmentTrackRecords[0].postalAddress.addressLine2 = "Istead Rise";
    this.selectedObject.developmentTrackRecords[0].postalAddress.addressLine3 = "Gravesend";
    this.selectedObject.developmentTrackRecords[0].postalAddress.addressLine4 = "Kent";
    this.selectedObject.developmentTrackRecords[0].postalAddress.postCode = "DA13 9JJ";
    const maxDate = Date.now();
    const timestamp = Math.floor(Math.random() * maxDate);
    this.selectedObject.developmentTrackRecords[0].acquistionDate = new Date(timestamp);
    this.selectedObject.developmentTrackRecords[0].acquistionCosts = this.getRandomIntInclusive(1000, 3000);
    this.selectedObject.developmentTrackRecords[0].didYouUseDevelopmentFinance = true;
    this.selectedObject.developmentTrackRecords[0].developmentFinanceLenderName = "Masthaven";
    this.selectedObject.developmentTrackRecords[0].developmentAreas = this.getRandomIntInclusive(2000, 3000).toString();
    this.selectedObject.developmentTrackRecords[0].buildCosts = this.getRandomIntInclusive(1000000, 2000000);
    this.selectedObject.developmentTrackRecords[0].buildTime = this.getRandomIntInclusive(5, 12);
    this.selectedObject.developmentTrackRecords[0].gdv = this.getRandomIntInclusive(10000000, 20000000);
    this.selectedObject.developmentTrackRecords[0].descriptionOfWorks = "Knock down and rebuild of main residence";

    this.selectedObject.developmentTrackRecords[1].ownerOrEmployee = OwnerOrEmployeeEnum.Owner;
    this.selectedObject.developmentTrackRecords[1].postalAddress.addressLine1 = "7 Soho Square";
    this.selectedObject.developmentTrackRecords[1].postalAddress.addressLine2 = "";
    this.selectedObject.developmentTrackRecords[1].postalAddress.addressLine3 = "London";
    this.selectedObject.developmentTrackRecords[1].postalAddress.addressLine4 = "";
    this.selectedObject.developmentTrackRecords[1].postalAddress.postCode = "W1D 3QB";
    this.selectedObject.developmentTrackRecords[1].acquistionDate = new Date(timestamp);
    this.selectedObject.developmentTrackRecords[1].acquistionCosts = this.getRandomIntInclusive(1000, 3000);
    this.selectedObject.developmentTrackRecords[1].didYouUseDevelopmentFinance = true;
    this.selectedObject.developmentTrackRecords[1].developmentFinanceLenderName = "Masthaven";
    (this.selectedObject.developmentTrackRecords[1].areaUnit = AreaUnitEnum.SquareMeters),
      (this.selectedObject.developmentTrackRecords[1].developmentAreas = this.getRandomIntInclusive(
        2000,
        3000,
      ).toString());
    this.selectedObject.developmentTrackRecords[1].buildCosts = this.getRandomIntInclusive(1000000, 2000000);
    this.selectedObject.developmentTrackRecords[1].buildTime = this.getRandomIntInclusive(12, 24);
    this.selectedObject.developmentTrackRecords[1].gdv = this.getRandomIntInclusive(10000000, 20000000);
    this.selectedObject.developmentTrackRecords[1].descriptionOfWorks =
      "Office to residential conversion on upper floors, and retention of the downstairs commercial - included a basement dig and 2 storey extension";
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  hasMinSecurityQuestionsBeenAnswered(shareholder: CaseMember) {
    let answers = 0;

    if (shareholder.dateOfBirth) {
      answers++;
    }

    if (shareholder.phoneNumber) {
      answers++;
    }

    if (shareholder.postalAddress.postCode) {
      answers++;
    }

    if (answers >= 2 || shareholder.isVerified) {
      return true;
    } else {
      return false;
    }
  }
}
